/**
 * React dependencies
 */

import React from 'react';

/**
 * DWT components
 */

import FeaturedFilter from './FilterItems/FeaturedFilter';
import FormatFilter from './FilterItems/FormatFilter';
import BrandFilter from './FilterItems/BrandFilter';
import ThemeFilter from './FilterItems/ThemeFilter';
import ChildrensCategoriesFilter from './FilterItems/ChildrensCategoriesFilter';
import LanguageFilter from './FilterItems/LanguageFilter';
import FilterPostItem from './FilterItems/FilterPostItem';
import AuthorLastInitialFilter from './FilterItems/AuthorLastInitialFilter';

/**
 * FilterOptions
 *
 * A component to render filters within an unordered list
 *
 * @param {Object} props
 * @param {Object} props.context
 * @param {Ojbect} props.setStart
 * @param {Array} props.categoryData
 * @param {boolean} props.categoryPost
 * @param {Array} props.imprintData
 * @param {boolean} props.imprintPost
 * @param {boolean} props.seriesPost
 * @param {boolean} props.ageRangePost
 * @param {boolean} props.collectionPost
 * @param {boolean} props.themePost
 * @param {Array} props.themeData
 * @param {Object} props.scrollToTop
 */
const FilterOptions = ({ context, setStart, brandData, brandPost, categoryData, categoryPost, imprintData, imprintPost, seriesPost, collectionPost, ageRangePost, themePost, themeData, scrollToTop }) => {
  const contributorsListing = context.featureBy === 'contributors';
  const formats = context?.selectedFormats ? JSON.parse( context.selectedFormats ) : [];
  const languages = context?.selectedLanguages ? JSON.parse( context.selectedLanguages ) : [];
  const childrensCategories = context?.selectedChildrensCategories ? JSON.parse( context.selectedChildrensCategories ) : [];

  return (
    !seriesPost && !collectionPost && (
      <div className='filters pt-20 pb-140 px-30 lg:p-0'>
        <h4 className='filters__list-heading m-0 text-14 text-[#606060] font-500 uppercase '>Filter By:</h4>
        <ul className='filters__list w-full list-none p-0'>
          { ( imprintPost || categoryPost ) && brandData.length > 0
            ? <BrandFilter
              context={ context }
              setStart={ setStart }
              filterPostType="brand"
              dataCode="data-brand-code"
              title="Brand"
              data={ brandData }
              scrollToTop={ scrollToTop }
              contributorsListing={ contributorsListing }
            />
            : null }
          { ageRangePost || imprintPost || contributorsListing || themePost
            ? <FilterPostItem
              context={ context }
              setStart={ setStart }
              filterPostType="bookcategory"
              dataCode="data-category-code"
              title="Category"
              data={ categoryData }
              scrollToTop={ scrollToTop }
              contributorsListing={ contributorsListing }
            />
            : null }
          { childrensCategories.length > 0
            ? <ChildrensCategoriesFilter
              context={ context }
              setStart={ setStart }
              dataCode="data-childrens-categories"
              scrollToTop={ scrollToTop }
            />
            : null }
          <FeaturedFilter
            context={ context }
            setStart={ setStart }
            scrollToTop={ scrollToTop }
          />
          { ageRangePost || categoryPost || contributorsListing || themePost
            ? <FilterPostItem
              context={ context }
              setStart={ setStart }
              filterPostType="imprint"
              dataCode="data-imprint-code"
              title="Imprint"
              data={ imprintData }
              scrollToTop={ scrollToTop }
              contributorsListing={ contributorsListing }
            />
            : null }
          { contributorsListing && (
            <AuthorLastInitialFilter
              setStart={ setStart }
              dataCode="data-author-last-initial"
              scrollToTop={ scrollToTop }
            />
          ) }
          { formats.length > 0
            ? <FormatFilter
              context={ context }
              setStart={ setStart }
              dataCode="data-format-codes"
              scrollToTop={ scrollToTop }
            />
            : null }
          { languages.length > 0
            ? <LanguageFilter
              context={ context }
              setStart={ setStart }
              dataCode="data-language-codes"
              scrollToTop={ scrollToTop }
            />
            : null }
          { themeData.length > 0 && ( imprintPost || categoryPost )
            ? <ThemeFilter
              context={ context }
              setStart={ setStart }
              filterPostType="theme"
              dataCode="data-theme-code"
              title="Theme"
              data={ themeData }
              scrollToTop={ scrollToTop }
              contributorsListing={ contributorsListing }
            />
            : null }
        </ul>
      </div>
    )
  );
};

export default FilterOptions;
